<div class="backdrop" [@backdropAnim]="animState">
    <div class="nps-modal" [@modalAnim]="animState" dir="rtl">

        <button class="nps-btn-close" (click)="closeModal()" aria-label="סגור">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M1 1L13 13M13 1L1 13" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
            </svg>
        </button>

        <h2 class="modal__title">{{ question }}</h2>

        <div class="scores-wrapper">
            <div class="scores-row">
                <button *ngFor="let score of scores"
                    [ngClass]="[getScoreClass(score), selectedScore === score ? 'is-selected' : '']"
                    (click)="selectScore(score)">{{ score }}</button>
            </div>
            <div class="scores-labels">
                <span>סביר מאד</span>
                <span>כלל לא סביר</span>
            </div>
        </div>

        <div class="comment-wrapper">
            <textarea class="comment-input" [(ngModel)]="comment"
                placeholder="מה הסיבה העיקרית לדירוג שבחרת? (אופציונלי)" rows="4"></textarea>
            <div class="comment-hint">המשוב אנונימי לחלוטין</div>
        </div>

        <button class="btn-submit" [class.is-enabled]="selectedScore !== null" [disabled]="selectedScore === null"
            (click)="submitFeedback()">
            שלח משוב
        </button>

    </div>
</div>